import React, {useState} from "react";
import { pushRotate as Menu } from "react-burger-menu";
import { Link, NavLink } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

export default props => {
    const style = {
        borderBottom: "1px solid white"
    }
    const applyBorder = () => {
        return style
    }
    const subSolution1  = [
        {to: "/solutions/extinguishers", label: "Fire extinguisher & standalone extinguisher"},
        {to: "/solutions/hydrant-sprinklers", label: "Hydrant & Sprinkler"},
        {to: "/solutions/total-flooding-systems", label: "Total Flooding Systems"},
        {to: "/solutions/specialized-stand-alone-extinguishers", label: "Specialized Stand Alone Extinguisher"}
      ]
    const subSolution2  = [
        {to: "/solutions/enterprise", label: "Enterprise"},
        {to: "/solutions/active-networking", label: "Active Networking"},
        {to: "/solutions/passive-networking", label: "Passive Networking"},
        {to: "/solutions/power", label: "Power"},
        {to: "/solutions/data-center", label: "Data Center"}
      ]
    const subSolution3  = [
        {to: "/solutions/network-security", label: "Network Security"}
      ]
    const subSolution4  = [
        {to: "/solutions/video-survillance", label: "Video Surveillance"},
        {to: "/solutions/alarm-systems", label: "Alarm Systems"},
        {to: "/solutions/access-control", label: "Access Control"},
        {to: "/solutions/entrance-management-systems", label: "Entrance Management Systems"},
        {to: "/solutions/scanning-systems", label: "Scanning Systems"}
      ]
    const subSolution5  = [
        {to: "/solutions/pre-sales", label: "Pre-Sales"},
        {to: "/solutions/implementation", label: "Post-Sales"},
        {to: "/solutions/annual-maintenance-contracts", label: "Annual Maintenance Contracts"}
      ]
      
    const [showHiddenMenu, setShowHiddenMenu] = useState(false)
    const [showHiddenSubMenu1, setShowHiddenSubMenu1] = useState(false)
    const [showHiddenSubMenu2, setShowHiddenSubMenu2] = useState(false)
    const [showHiddenSubMenu3, setShowHiddenSubMenu3] = useState(false)
    const [showHiddenSubMenu4, setShowHiddenSubMenu4] = useState(false)
    const [showHiddenSubMenu5, setShowHiddenSubMenu5] = useState(false)

    const showSolutions = () => {
        applyBorder()
        if(!showHiddenMenu) setShowHiddenMenu(true);
        else {
            setShowHiddenMenu(false);
            collapseAllMenus();
        }
    }
    const showSubSolution1 = () => {
        if(!showHiddenSubMenu1) {
            setShowHiddenSubMenu1(true);
            setShowHiddenSubMenu2(false);
            setShowHiddenSubMenu3(false);
            setShowHiddenSubMenu4(false);
            setShowHiddenSubMenu5(false);
        }
        else setShowHiddenSubMenu1(false);
    }
    const showSubSolution2 = () => {
        if(!showHiddenSubMenu2) {
            setShowHiddenSubMenu1(false);
            setShowHiddenSubMenu2(true);
            setShowHiddenSubMenu3(false);
            setShowHiddenSubMenu4(false);
            setShowHiddenSubMenu5(false);
        }
        else setShowHiddenSubMenu2(false);
    }
    const showSubSolution3 = () => {
        if(!showHiddenSubMenu3) {
            setShowHiddenSubMenu1(false);
            setShowHiddenSubMenu2(false);
            setShowHiddenSubMenu3(true);
            setShowHiddenSubMenu4(false);
            setShowHiddenSubMenu5(false);
        }
        else setShowHiddenSubMenu3(false);
    }
    const showSubSolution4 = () => {
        if(!showHiddenSubMenu4) {
            setShowHiddenSubMenu1(false);
            setShowHiddenSubMenu2(false);
            setShowHiddenSubMenu3(false);
            setShowHiddenSubMenu4(true);
            setShowHiddenSubMenu5(false);
        }
        else setShowHiddenSubMenu4(false);
    }
    const showSubSolution5 = () => {
        if(!showHiddenSubMenu5) {
            setShowHiddenSubMenu1(false);
            setShowHiddenSubMenu2(false);
            setShowHiddenSubMenu3(false);
            setShowHiddenSubMenu4(false);
            setShowHiddenSubMenu5(true);
        }
        else setShowHiddenSubMenu5(false);
    }
    const collapseAllMenus = () => {
        setShowHiddenMenu(false);
        setShowHiddenSubMenu1(false);
        setShowHiddenSubMenu2(false);
        setShowHiddenSubMenu3(false);
        setShowHiddenSubMenu4(false);
        setShowHiddenSubMenu5(false);
    }

    return (
        <Menu>
        <ul id="nav-links" className="mui-fixed">
            <li className="menu-item"><NavLink exact to="/" onClick={collapseAllMenus} activeClassName="selected">Home</NavLink></li>
            <li className="menu-item"><NavLink to="/company" onClick={collapseAllMenus} activeClassName="selected">Company</NavLink></li>
            <li className="menu-item"><NavLink to="/products" onClick={collapseAllMenus} activeClassName="selected">Products</NavLink></li>
            <li><NavLink to="#" onClick={showSolutions}>Solutions<span><FontAwesomeIcon icon={faChevronDown} style={{ color: '#fff', float: 'right', marginTop: '5px' }} size="sm" /></span></NavLink>
            { showHiddenMenu ? 
                <ul className="hidden-menu">
                    <li><Link to="/solutions/fire-safety-precaution" onClick={showSubSolution1} className="menu-item">Fire, Safety &amp; Precaution<span><FontAwesomeIcon icon={faChevronDown} style={{ color: '#fff', float: 'right', marginTop: '5px' }} size="sm" /></span></Link>
                    { showHiddenSubMenu1 ?
                        <ul className="hidden-menu">
                            {subSolution1.map((rows, index) => {
                                return(
                                   <li><Link to={rows.to}>{rows.label}</Link></li>
                                )}
                            )}
                        </ul>
                    : null }
                    </li>
                    <li><Link to="/solutions/information-communication-technology" onClick={showSubSolution2} className="menu-item">Information Technology<span><FontAwesomeIcon icon={faChevronDown} style={{ color: '#fff', float: 'right', marginTop: '5px' }} size="sm" /></span></Link>
                    { showHiddenSubMenu2 ?
                        <ul className="hidden-menu">
                            {subSolution2.map((rows, index) => {
                                return(
                                   <li><Link to={rows.to}>{rows.label}</Link></li>
                                )}
                            )}
                        </ul>
                    : null }
                    </li>
                    <li><Link to="/solutions/IT-Security" className="menu-item" onClick={showSubSolution3}>IT Security<span><FontAwesomeIcon icon={faChevronDown} style={{ color: '#fff', float: 'right', marginTop: '5px' }} size="sm" /></span></Link>
                    { showHiddenSubMenu3 ?
                        <ul className="hidden-menu">
                            {subSolution3.map((rows, index) => {
                                return(
                                   <li><Link to={rows.to}>{rows.label}</Link></li>
                                )}
                            )}
                        </ul>
                    : null }
                    </li>
                    <li><Link to="/solutions/physical-security" className="menu-item" onClick={showSubSolution4}>Physical Security<span><FontAwesomeIcon icon={faChevronDown} style={{ color: '#fff', float: 'right', marginTop: '5px' }} size="sm" /></span></Link>
                    { showHiddenSubMenu4 ?
                        <ul className="hidden-menu">
                            {subSolution4.map((rows, index) => {
                                return(
                                   <li><Link to={rows.to}>{rows.label}</Link></li>
                                )}
                            )}
                        </ul>
                    : null }
                    </li>
                    <li><Link to="/solutions/services" className="menu-item" onClick={showSubSolution5}>Services<span><FontAwesomeIcon icon={faChevronDown} style={{ color: '#fff', float: 'right', marginTop: '5px' }} size="sm" /></span></Link>
                    { showHiddenSubMenu5 ?
                        <ul className="hidden-menu">
                            {subSolution5.map((rows, index) => {
                                return(
                                   <li><Link to={rows.to}>{rows.label}</Link></li>
                                )}
                            )}
                        </ul>
                    : null }
                    </li>
                </ul>
            : null }
            </li>
            <li className="menu-item"><NavLink to="/business-associates" onClick={collapseAllMenus} activeClassName="selected">Business Associates</NavLink></li>
            <li className="menu-item"><NavLink to="/contact-us" onClick={collapseAllMenus} activeClassName="selected">Contact</NavLink></li>
        </ul>
        </Menu>
  );
};